import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Observable } from 'rxjs';
import { Globle } from 'src/assets/globle';
import { EFCategory } from '../../category/efCategory.model';
import { EfcategoryService } from '../../category/efcategory.service';
import { BillerList } from '../billerlist.model';
import { BillerlistService } from '../billerlist.service';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-billersform',
  templateUrl: './billersform.component.html',
  styleUrls: ['./billersform.component.css']
})
export class BillersformComponent implements OnInit {

  //#region variables
  category: EFCategory = {} as EFCategory;
  Categories: EFCategory[] = [];
  subCategory: BillerList = {} as BillerList;
  updateMode = false;
  imagPath: any;
  active = true;
  spinnerOverlay = false;
  filteredOptions!: Observable<EFCategory[]>;
  searchCategory = new FormControl();
  _submit = false;
  language!: number;

  constructor(private router: Router,
    private categoryService: EfcategoryService,
    private service: BillerlistService,
    private globle: Globle,
    private snackBar: MatSnackBar,
    private activateRoute: ActivatedRoute,
    private localStorage: LocalStorageService,
    private translate: TranslateService) { }

  ngOnInit(): void {
    this.imagPath = this.globle.imgPath;
    this.language = this.localStorage.retrieve("lang");
    this.getUrlParam();
  }

  getUrlParam() {
    this.activateRoute.paramMap.subscribe(param => {
      if (param.get("id") != null) {
        this.subCategory.id = +param.get("id")!;
        this.updateMode = true;
        this.getById();
      }
    })
  }

  getById() {
    this.service.getById(this.subCategory.id).subscribe(data => {
      this.subCategory = data
      this.subCategory.status == 1 ? this.active = true : this.active = false;
    })
  }

  back() {
    this.router.navigate(["./master/efawateercome/efbillerslist"]);
  }

  submit() {

    this.spinnerOverlay = true;
    this.active ? this.subCategory.status = 1 : this.subCategory.status = 0;
    this.update()
  }

  update() {
    this.spinnerOverlay = true;
    this.service.Update(this.subCategory).subscribe(data => {
      this.spinnerOverlay = false;
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.back();
    },
      error => {
        console.log(error);
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }
        this.spinnerOverlay = false;
      })
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

}
